@if (isVisible()) {
  <div
    class="tour-backdrop"
    animate.enter="tour-backdrop--enter"
    animate.leave="tour-backdrop--leave"
    >
    <div class="tour-ambient">
      <div class="tour-ambient__orb tour-ambient__orb--1"></div>
      <div class="tour-ambient__orb tour-ambient__orb--2"></div>
      <div class="tour-ambient__orb tour-ambient__orb--3"></div>
    </div>
  </div>
}

@if (isVisible()) {
  <div
    class="tour-card-wrap"
    animate.enter="tour-card-wrap--enter"
    animate.leave="tour-card-wrap--leave"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="ariaLabel()"
    >
    <div class="tour-card" (click)="$event.stopPropagation()">
      @if (!isLastStep()) {
        <button
          class="tour-skip"
          (click)="skip()"
          [attr.aria-label]="'pageTour.skip' | transloco"
          >
          {{ "pageTour.skip" | transloco }}
          <i class="ft-x" aria-hidden="true"></i>
        </button>
      }
      <div class="tour-illustration" [style.background]="step().accentGradient">
        <div class="tour-illustration__ring tour-illustration__ring--1"></div>
        <div class="tour-illustration__ring tour-illustration__ring--2"></div>
        <div class="tour-illustration__ring tour-illustration__ring--3"></div>
        <div class="tour-illustration__orb" [style.background]="step().orbGradient">
          <svg
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
            >
            <path [attr.d]="step().svgPath" />
          </svg>
        </div>
        <div class="tour-illustration__counter">
          {{ currentStep() + 1 }} / {{ steps().length }}
        </div>
      </div>
      <div class="tour-content">
        <div class="tour-step-content">
          @for (current of [step()]; track currentStep()) {
            <div
              class="tour-step-content__inner"
              [animate.enter]="direction() === 'forward' ? 'tour-step--from-right' : 'tour-step--from-left'"
            >
              <h2 class="tour-title">{{ current.title | transloco }}</h2>
              <p class="tour-desc">{{ current.description | transloco }}</p>
            </div>
          }
        </div>
        <div class="tour-progress">
          <div
            class="tour-progress__fill"
            [style.width.%]="progressPercent()"
          ></div>
        </div>
        <div class="tour-dots">
          @for (s of steps(); track s; let i = $index) {
            <button
              class="tour-dot"
              [class.tour-dot--active]="i === currentStep()"
              [class.tour-dot--done]="i < currentStep()"
              (click)="goTo(i)"
              [attr.aria-label]="'pageTour.goToStep' | transloco: { number: (i + 1), title: s.title }"
            ></button>
          }
        </div>
        <div class="tour-actions">
          @if (!isFirstStep()) {
            <button
              class="tour-btn tour-btn--back"
              (click)="back()"
              [attr.aria-label]="'pageTour.previousStep' | transloco"
              >
              <i class="ft-arrow-left" aria-hidden="true"></i>
              {{ "pageTour.back" | transloco }}
            </button>
          }
          @if (isFirstStep()) {
            <div class="tour-actions__spacer"></div>
          }
          <button
            class="tour-btn tour-btn--next"
            (click)="next()"
            [attr.aria-label]="(isLastStep() ? 'pageTour.completeTour' : 'pageTour.nextStep') | transloco"
            >
            {{ (isLastStep() ? "pageTour.getStarted" : "pageTour.next") | transloco }}
            <i
              [class]="isLastStep() ? 'ft-check' : 'ft-arrow-right'"
              aria-hidden="true"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </div>
}
